var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bio-container"},[_c('img',{attrs:{"src":require('@/assets/images/bio.jpg'),"alt":"bio","height":"100%","width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }